import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

interface BrandLogoProps {
    className?: string
    onClick?: () => void
}

export const BrandLogo: FC<BrandLogoProps> = ({ className, onClick }): ReactNode => {
    return (
        <Link
            href='/'
            onClick={onClick}
            aria-label='Anushka Beauty Parlour, home'
            className={cn(
                'flex flex-col items-start leading-none focus-visible:rounded-md focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold',
                className
            )}
        >
            <span className='gold-shine pr-1 font-heading text-[1.35rem] font-bold tracking-[0.2em] sm:text-2xl'>
                Anushka
            </span>

            <span className='mt-1 text-[0.6rem] font-medium uppercase tracking-[0.46em] text-gold-light/80 sm:text-[0.65rem]'>
                Beauty Parlour
            </span>
        </Link>
    )
}
